import React from 'react';
import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { NotificationType } from '@identity/types';
import { FontSize } from '@common/tokens';

type NotificationProps = {
  notification: NotificationType;
  updateNotifications: (action: {
    notifications: NotificationType[];
    enabled: boolean;
  }) => void;
};

export function Notification({
  notification,
  updateNotifications,
}: NotificationProps) {
  function onNotificationChange(e: CheckboxChangeEvent) {
    updateNotifications({
      notifications: [notification],
      enabled: e.target.checked,
    });
  }

  return (
    <>
      <div
        key={notification.notificationName}
        className="account-settings__notifications-section__notification"
      >
        <Checkbox
          checked={notification.enabledForCurrentMembership}
          onChange={onNotificationChange}
        >
          {notification.humanizedName}
        </Checkbox>
      </div>
      <style jsx>{`
        .account-settings__notifications-section__notification {
          width: 100%;
          margin-bottom: 12px;
        }

        .account-settings__notifications-section__notification
          :global(.ant-checkbox-wrapper) {
          font-size: ${FontSize.md};
        }
      `}</style>
    </>
  );
}
